import angular from 'angular';

import nodeGraphView from './node-graph-view.component';

export default angular
	.module('app.node-graph-view', [])
	.component('nodeGraphView', nodeGraphView)
	.name;
